import { useState } from "react";

export const useButtonLocationDialog = () => {
  const [admins, setAdmins] = useState({});
  const [marketers, setMarketers] = useState({});
  const [schedulers, setSchedulers] = useState({});
  const [selectedSenders, setSelectedSenders] = useState({});
  const [selectedProviders, setSelectedProviders] = useState({});
  const [selectedSpecialists, setSelectedSpecialists] = useState([]);

  const setNewlyAddedProvider = ({ id, name, speciality }) =>
    setSelectedProviders((prevState) => ({
      ...prevState,
      [id]: {
        label: [name, speciality].filter(Boolean).join(" | "),
        selected: true,
      },
    }));

  const setNewlyAddedSender = ({
    id,
    firstName,
    lastName,
    jobTitle,
    phone,
    email,
  }) =>
    setSelectedSenders((prevState) => ({
      ...prevState,
      [id]: {
        label: [`${firstName} ${lastName}`, jobTitle, phone, email]
          .filter(Boolean)
          .join(" | "),
        selected: true,
      },
    }));

  const [isDataChanged, setIsDataChanged] = useState(false);

  const isAdminSelected = Object.keys(admins).find((id) =>
    selectedSpecialists?.includes(id)
  );
  const isMarketerSelected = Object.keys(marketers).find((id) =>
    selectedSpecialists?.includes(id)
  );
  const isSchedulerSelected = Object.keys(schedulers).find((id) =>
    selectedSpecialists?.includes(id)
  );

  const isSenderSelected = Object.keys(selectedSenders).find(
    (id) => selectedSenders[id].selected
  );

  const isProviderSelected = Object.keys(selectedProviders).find(
    (id) => selectedProviders[id].selected
  );

  const isUpdateButtonDisabled =
    (!isSchedulerSelected && !isMarketerSelected && !isAdminSelected) ||
    !isDataChanged;

  const handleChangeProvider = (e, id, label) => {
    setIsDataChanged(true);

    const unckeckedProviders = Object.keys(selectedProviders)
      .map((providerId) => ({
        [providerId]: {
          label: selectedProviders[providerId].label,
          selected: false,
        },
      }))
      .reduce((acc, curr) => ({ ...acc, ...curr }), {});

    setSelectedProviders({
      ...unckeckedProviders,
      [id]: {
        label,
        selected: true,
      },
    });
  };

  const handleChangeSpecialist = (e, role, id, label, onlyOne = false) => {
    setIsDataChanged(true);

    if (role === "Originator") {
      const preparedSenders = onlyOne
        ? Object.keys(selectedSenders)
            .map((senderId) => ({
              [senderId]: {
                label: selectedSenders[senderId].label,
                selected: false,
              },
            }))
            .reduce((acc, curr) => ({ ...acc, ...curr }), {})
        : selectedSenders;

      setSelectedSenders({
        ...preparedSenders,
        [id]: {
          label,
          selected: e.target.checked,
        },
      });
      return;
    }

    if (["Admin", "Marketer", "Scheduler"].includes(role)) {
      setSelectedSpecialists((prevState) => {
        if (e.target.checked) {
          return [...prevState, id];
        }
        return prevState.filter((value) => value !== id);
      });
    }
  };

  return {
    selectedSenders,
    setSelectedSenders,
    setNewlyAddedSender,
    selectedProviders,
    setSelectedProviders,
    setNewlyAddedProvider,
    admins,
    setAdmins,
    marketers,
    setMarketers,
    schedulers,
    setSchedulers,
    isUpdateButtonDisabled,
    handleChangeSpecialist,
    handleChangeProvider,
    isDataChanged,
    isSchedulerSelected,
    isMarketerSelected,
    isAdminSelected,
    isSenderSelected,
    isProviderSelected,
    selectedSpecialists,
    setSelectedSpecialists,
  };
};
